import React, {useState, useContext} from 'react';
import './ChangePasswordForm.scss';
import {I18nContext} from '../../contexts/i18nContext';
import {AdminContext} from '../../contexts/adminContext';
import {Button, SelectInput, TextInput} from '../_common';
const ChangePasswordForm = ({primaryButtonAction, secondaryButtonAction, user}) => {
  const { t } = useContext(I18nContext);
  const {
    changePasswordPending,
    error,
  } = useContext(AdminContext);

  const [formValues, setFormValues] = useState({
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: ''
  });
  const [passwordStrengthError, setPasswordStrengthError] = useState(false);
  const [passwordMatchError, setPasswordMatchError] = useState(false);

  const changeValue = (name, value) => {
    if (name === "newPassword" || name === "confirmNewPassword") {
      setPasswordStrengthError(false);
      setPasswordMatchError(false);
    }
    const newValues = {...formValues};
    newValues[name] = value;
    setFormValues(newValues);
  };

  const checkPasswordStrength = (password) => {
    const regex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    return regex.test(password);
  };

  const checkPasswordMatch = (passwordOne, passwordTwo) => {
    return passwordOne === passwordTwo;
  };

  const handleChangePasswordClick = (values) => {
    if (!checkPasswordStrength(values.newPassword)) {
      setPasswordStrengthError(true);
    } else if (!checkPasswordMatch(values.newPassword, values.confirmNewPassword)) {
      setPasswordMatchError(true);
    } else {
      primaryButtonAction(values);
    }
  };

  return (
    <form className='UserForm' autoComplete='off'>
      <div className='formInputs'>
        {!!user && (
          <TextInput
            label={t('current password')}
            required
            name='currentPassword'
            placeholder={t('enter password')}
            onChange={changeValue}
            value={formValues.currentPassword}
            type={'password'}
          />
        )}
        <TextInput
          label={t('new password')}
          required
          name='newPassword'
          placeholder={t('enter password')}
          onChange={changeValue}
          value={formValues.newPassword}
          type={'password'}
        />
        {passwordStrengthError && (
          <div className='errorMessage'>
            {t('the password should consist of a least 8 characters, 1 capital letter, 1 number and 1 special character')}.
          </div>
        )}
        <TextInput
          label={t('confirm new password')}
          required
          name='confirmNewPassword'
          placeholder={t('enter password')}
          onChange={changeValue}
          value={formValues.confirmNewPassword}
          type={'password'}
        />
        {passwordMatchError && (
          <div className='errorMessage'>
            {t('inputted values do not match')}.
          </div>
        )}
      </div>
      <div className='formButtons'>
        <Button type='secondary' action={secondaryButtonAction} label={t('cancel')} />
        <Button
          type='primary'
          action={() => handleChangePasswordClick(formValues)}
          label={t('save')}
          margin='left'
          disabled={changePasswordPending}
          pending={changePasswordPending}
        />
      </div>
    </form>
  );
};

export default ChangePasswordForm;
